import { gql } from "@apollo/client";export default gql`query collectionAggregate($where: collection_bool_exp) {
    collectionAggregate: collection_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
